import React from 'react';
import Percent from '@mui/icons-material/Percent';

const specialTicketChipsData = [
    // for round-trip Munich booking AND both transfers have exactly one person
    {
        servicePackCode: 'COLLECTIVE_COMBO', // servicePackCode is a unique value
        color: 'secondary',
        backgroundColor: '#fff9e9',
        label: 'discountedTicketLabelServicePackCode.COLLECTIVE_COMBO',
        icon: <Percent />,
    },
    {
        servicePackCode: 'COLLECTIVE2',
        color: 'secondary',
        backgroundColor: '#fff9e9',
        label: 'discountedTicketLabelServicePackCode.COLLECTIVE2',
        icon: <Percent />,
    },
    {
        servicePackCode: 'COLLECTIVE_FAMILY',
        color: 'secondary',
        backgroundColor: '#fff9e9',
        label: 'discountedTicketLabelServicePackCode.COLLECTIVE_FAMILY',
        icon: <Percent />,
    },
    {
        servicePackCode: 'krones1',
        color: 'secondary',
        backgroundColor: '#fff9e9',
        label: 'discountedTicketLabelServicePackCode.krones1',
        icon: <Percent />,
    },
    // Munich round trip where a leg has 2-7 persons and no family constellation
    {
        servicePackCode: 'COLLECTIVE_PARTNER_ADVANTAGE',
        color: 'secondary',
        backgroundColor: '#fff9e9',
        label: 'discountedTicketLabelServicePackCode.COLLECTIVE_PARTNER_ADVANTAGE',
        icon: <Percent />,
    },
];

const getSpecialTicketChips = (servicePackCodes) => {
    if (!Array.isArray(servicePackCodes)) {
        return [];
    }

    return specialTicketChipsData.filter((item) => servicePackCodes.includes(item.servicePackCode));
};

export { getSpecialTicketChips };
